import { DocumentFilterDimensions } from "api";

const mapApiDocumentFilterDimensions = (
  dimensions: DocumentFilterDimensions
): FrontEndDocumentFilterDimensions => ({
  products: dimensions.Products ?? [],
  shipFromWarehouses: dimensions.ShipFromWarehouses ?? [],
  shipToAddresses: dimensions.ShipToAddresses ?? [],
  salesTerms: dimensions.SalesTerms ?? [],
  modeOfTransportations: dimensions.ModeOfTransportations ?? [],
  documentStatuses: dimensions.DocumentStatuses ?? [],
});

export default mapApiDocumentFilterDimensions;
